goog.module('yext.plugins.ajaxChosen');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');

// Generated by CoffeeScript 1.3.1
// NOTE(vple): This file has been modified from the original generated file.

(function($) {
  $.fn.ajaxChosen = function(settings, callback, chosenOptions) {
    var chosenXhr; var defaultOptions; var options; var select;
    if (settings == null) {
      settings = {};
    }
    if (chosenOptions == null) {
      chosenOptions = {};
    }
    defaultOptions = {
      minTermLength: 3,
      afterTypeDelay: 500,
      jsonTermKey: 'term',
      // TRANSLATORS: Prompt for the user to keep typing in the search box to select a location to post to.
      keepTypingMsg: yext.msg('Keep typing...'),
      // TRANSLATORS: After the user has typed a string in the location search box, the search is performed on the locations for match.
      // EXAMPLE: Looking for '1 Madison Ave'
      lookingForMsg: yext.msg('Looking for'),
    };
    select = this;
    chosenXhr = null;
    options = $.extend({}, defaultOptions, $(select).data(), settings);

    this.chosen(chosenOptions ? chosenOptions : {});
    return this.each(function() {
      $(this).next('.chosen-container')
        .find('.search-field > input, .chosen-search > input')
        .bind('paste', function() {
          var e = $.Event('keyup');
          // $(this).val() is not yet updated at paste event, so
          // send the keyup event asynchronously but quickly
          setTimeout(() => $(this).trigger(e), 0);
        })
        .bind('keyup', function() {
          var field; var msg; var success; var untrimmed_val; var val;
          untrimmed_val = $(this).val();
          val = $.trim($(this).val());
          if (val === $(this).data('prevVal')) {
            return false;
          }

          msg = val.length < options.minTermLength
            ? options.keepTypingMsg
            : options.lookingForMsg + (' \'' + val + '\'');
          select.next('.chosen-container').find('.no-results').text(msg);

          $(this).data('prevVal', val);
          if (this.timer) {
            clearTimeout(this.timer);
          }
          if (val.length < options.minTermLength) {
            return false;
          }

          field = $(this);
          if (options.data == null) {
            options.data = {};
          }
          options.data[options.jsonTermKey] = val;
          if (options.dataCallback != null) {
            options.data = options.dataCallback(options.data);
          }

          success = options.success;
          options.success = function(data) {
            if (data == null) {
              return;
            }

            // Clear select options. Preserves any selected options.
            var selected_values = [];
            select.find('option').each(function() {
              if (!$(this).is(':selected')) {
                $(this).remove();
              } else {
                selected_values.push($(this).val() + '-' + $(this).text());
              }
            });
            select.find('optgroup:empty').each(function() {
              $(this).remove();
            });

            // Add items to select.
            var items = callback != null ? callback(data, field) : data;
            var nbItems = 0;
            $.each(items, function(i, element) {
              var group; var text; var value;
              nbItems++;
              if (element.group) { // element is an optgroup
                group = select.find('optgroup[label="' + element.text + '"]');
                if (!group.size()) {
                  group = $('<optgroup />');
                }
                group.attr('label', element.text).appendTo(select);

                // populate optgroup
                $.each(element.items, function(i, element) {
                  var text; var value;
                  if (typeof element === 'string') {
                    value = i;
                    text = element;
                  } else {
                    value = element.value;
                    text = element.text;
                  }
                  if ($.inArray(value + '-' + text, selected_values) === -1) {
                    $('<option />').attr('value', value).html(text).appendTo(group);
                  }
                });
              } else { // element is an option
                if (typeof element === 'string') {
                  value = i;
                  text = element;
                } else {
                  value = element.value;
                  text = element.text;
                }
                if ($.inArray(value + '-' + text, selected_values) === -1) {
                  $('<option />').attr('value', value).html(text).appendTo(select);
                }
              }
            });

            if (nbItems) {
              var currentVal = field.val();
              select.trigger('chosen:updated');
              field.val(currentVal);
            } else {
              select.data()['chosen'].update_results_content('');
              select.data()['chosen'].no_results_clear();
              select.data()['chosen'].no_results(field.val());
            }
            if (settings.success != null) {
              settings.success(data);
            }
          };

          // Start AJAX search after a delay.
          this.timer = setTimeout(function() {
            if (chosenXhr) {
              chosenXhr.abort();
            }
            chosenXhr = $.ajax(options);
          }, options.afterTypeDelay);
        });
    });
  };
})(jQuery);

